<template>
    <Header></Header>
    <main>
        <Banner v-if="fields" :fields="fields['First Section']"></Banner>
        <SlideBlock v-if="fields" :fields="fields['Second section']" style="padding-bottom: 144px; padding-top: 98px;"></SlideBlock>
        <SlideBlock v-if="fields" :fields="fields['Third section']" style="padding-bottom: 180px;"></SlideBlock>
        <BlueBlock v-if="fields['Fourth section']" :fields="fields['Fourth section']"></BlueBlock>
        <FormBlock v-if="fields['Fifth section']" :fields="fields['Fifth section']" style="padding-top: 160px; padding-bottom: 160px;"></FormBlock>
        <ServicesTemplate v-if="fields['Sixth section']" :fields="fields['Sixth section']" style="padding-bottom: 160px;"></ServicesTemplate>
        <OurBlog v-if="fields['Our Blog']" :fields="fields['Our Blog']"></OurBlog>
        <SloganTempate v-if="fields['Eighth section']" :fields="fields['Eighth section']" style="padding-top: 160px; padding-bottom: 160px;"></SloganTempate>
        <PosotionImgContentLeft
        :content="{
            imagePosition: 'left'
        }"
        ></PosotionImgContentLeft>
        <FaqBlock style="padding-top: 160px; padding-bottom: 120px;"></FaqBlock>
    </main>
    <Footer></Footer>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Banner from "@/components/Home/Banner.vue";
import Footer from "@/components/Footer/Footer.vue";
import SlideBlock from "@/components/Templates/SlideBlock.vue";
import BlueBlock from "@/components/Templates/BlueBlock.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import FormBlock from "@/components/Templates/FormBlock.vue";
import OurBlog from "@/components/Templates/OurBlog.vue";
import PosotionImgContentLeft from "@/components/Templates/PosotionImgContentLeft.vue";
import SloganTempate from "@/components/Templates/SloganTempate.vue";
import ServicesTemplate from "@/components/Templates/ServicesTemplate.vue";
import { registerAnimations } from '@/assets/directives/animations';
import axios from 'axios'
export default {
    components: {
        Header,
        Banner,
        Footer,
        SlideBlock,
        BlueBlock,
        FaqBlock,
        FormBlock,
        OurBlog,
        PosotionImgContentLeft,
        SloganTempate,
        ServicesTemplate
    },
    computed: {
        fields() {
            return this.$store.state.fields;
        },
    },
    watch: {
    '$route': 'fetchData', // Следим за изменением маршрута
    },
    methods: {
    fetchData() {
        axios.get('/api/data', { params: { url: this.$route.path } })
        .then(response => {
            this.$nextTick(() => {
                registerAnimations(); // Инициализация анимаций после загрузки данных
            });
        });
    },
    },
    created() {
    this.fetchData(); // Загружаем данные при создании компонента
    },
}
</script>

<style scoped>

</style>